var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays the end-of-journey page when the claim does not require any administrative follow-up.
 * touches: declaration, claim lifecycle, selfCareSettings
 * invariants: The displayed illustration, subtitle and continuation action are driven by insurer configuration; no case number is displayed on this page.
 * inputs: selfCareSettings.declaration.pages.noAdministrativeFollowupIndex
 * outputs: Renders the final informational page and configures the available continuation action for the claimant.
 * see: @declaration/components/TitleImageDescriptionLayout, @declaration/store/settings, @shared/insurer
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
const settings = namespace('settings');
let NoAdministrativeFollowupIndex = class NoAdministrativeFollowupIndex extends Vue {
    constructor() {
        super(...arguments);
        this.illustrations = {
            illustrationDenied: require('@declaration/assets/images/documents/refus.svg'),
            illustrationTotalDenied: require('@declaration/assets/images/documents/refus-total.svg'),
        };
    }
    get illustrationKey() {
        var _a, _b, _c, _d;
        return (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.noAdministrativeFollowupIndex) === null || _d === void 0 ? void 0 : _d.illustration;
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get subTitle() {
        var _a, _b, _c, _d;
        return ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.noAdministrativeFollowupIndex) === null || _d === void 0 ? void 0 : _d.showSubtitle)
            ? this.$tc('error.claim.administrative.no-followup.subtitle')
            : null;
    }
    get illustration() {
        if (this.illustrationKey !== undefined) {
            return this.illustrations[this.illustrationKey];
        }
        else {
            return this.illustrations.illustrationDenied;
        }
    }
    get continuation() {
        var _a, _b, _c, _d;
        return ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.noAdministrativeFollowupIndex) === null || _d === void 0 ? void 0 : _d.hideContinuation)
            ? null
            : 'quit';
    }
};
__decorate([
    settings.Getter('setting')
], NoAdministrativeFollowupIndex.prototype, "setting", void 0);
NoAdministrativeFollowupIndex = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
            goBack: null,
        },
    })
], NoAdministrativeFollowupIndex);
export default NoAdministrativeFollowupIndex;
